export const liveReportConstants = {
    SAVE_DIAGNOSTIC: "SAVE_DIAGNOSTIC",
    DELETE_DIAGNOSTIC: "DELETE_DIAGNOSTIC",
    CLEAR_DIAGNOSTICS: "CLEAR_DIAGNOSTICS",
}
